import {
  save,
  modify,
  getByArticleUuid,
  removeArticleSense,
} from '@/services/internal/article/ArticleSense';
import{getSense} from '@/services/forward/in/FreshReceive';
export default {
  namespace: 'articleSense',

  state: {
  },

  effects: {
    *save({ payload, callback }, { call, put }) {
      const response = yield call(save, payload);
      if (callback) callback(response);
    },

    *modify({ payload, callback }, { call, put }) {
      const response = yield call(modify, payload);
      if (callback) callback(response);
    },

    *getByArticleUuid({ payload, callback }, { call, put }) {
      const response = yield call(getByArticleUuid, payload);
      if (response && response.success) {
        yield put({
            type: 'saveSences',
            payload: response.data
        });
    }
      if (callback) callback(response);
    },

    *removeArticleSense({ payload, callback }, { call, put }) {
      const response = yield call(removeArticleSense, payload);
      if (callback) callback(response);
    },

    //生鲜收货查看质检结果时调用
    *getByArticleUuidAndBillNumber({ payload, callback }, { call, put }) {
      const response = yield call(getSense, payload);
      if (callback) callback(response);
    },
  },

  reducers: {
    saveSences(state,action) {
      return {
        ...state,
        articleSenses: action.payload,
      }
    }
  }
}
